import { useIonRouter } from "@ionic/vue";
import { storeToRefs } from "pinia";
import { useExplotacionStore } from "@/stores/store.explotacion"
import { Explotacion } from "@/models/Explotacion";
import ExplotacionApi from "@/api/explotacion";
import { showLoading, hideLoading } from "@/helpers/loadingHelper";
import { showAlert } from "@/helpers/alertHelper";
export const useExplotacion = () => {
    
    const ionRouter = useIonRouter();
    const explotacionStore = useExplotacionStore();
    const { explotacion,explotaciones } = storeToRefs(explotacionStore);

    const setExplotacion = async (explotacion:Explotacion) => {
        await explotacionStore.clear();
        await explotacionStore.set(explotacion);
        ionRouter.push('/tabs/explotacion');
    }

    const getExplotacion = async () => {
        explotacion.value = await explotacionStore.get;
        return explotacion.value;
    }

    const listExplotaciones = async () => {
        try{
            showLoading('Cargando explotaciones...');
            explotaciones.value = await ExplotacionApi.listar();
            hideLoading();
        }catch(error){
            hideLoading();
            showAlert('Error!', 'Disculpe, no se han podido cargar las explotaciones');
            console.error(error);
        }
        
    }

    return {
        //! Properties
        explotacion,
        explotaciones,

        //! Methods
        setExplotacion,
        getExplotacion,
        listExplotaciones,
    }
}